import { ChangeEvent, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Domain from "@material-ui/icons/Domain";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import DesktopMac from "@material-ui/icons/DesktopMac";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import TabPanels from "./components/tabpanels";
import TabPanel from "./components/tabpanel";
import DepartmentListTabPanel from "./department/list";
import { AttendanceLocal } from "../../../../../@types/attendance-local";
import UserListTabPanel from "./user/list";
import GuicheListTabPanel from "./guiche/list";
import ServiceListTabPanel from "./service/list";
import { useSearchParams } from "../../../../../hooks/useSearchParams";
import { useDetailsTabsStyles } from "./styles";

type DetailsTabsProps = {
    attendanceLocal: AttendanceLocal
}

export default function DetailsTabs({ attendanceLocal }: DetailsTabsProps) {
    const history = useHistory();
    const { pathname } = useLocation();
    const { classes } = useDetailsTabsStyles();
    const searchParams = useSearchParams();

    const value = useMemo(() => {
        const tab = Number(searchParams.get('active_tab'));
        if (isNaN(tab) || tab < 0 || tab > 3) {
            return 0;
        }
        return tab;
    }, [searchParams]);

    const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
        history.replace(`${pathname}?active_tab=${newValue}`);
    };

    return (
        <Box>
            <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="disabled tabs example"
            >
                <Tab label="Setores" icon={<Domain />} classes={{ root: classes.tabRoot }} />
                <Tab label="Usuários" icon={<PeopleAlt />} classes={{ root: classes.tabRoot }} />
                <Tab label="Serviços" icon={<DesktopMac />} classes={{ root: classes.tabRoot }} />
                <Tab label="Guichês de Recepção" icon={<DesktopWindows />} classes={{ root: classes.tabRoot }} />
            </Tabs>
            <TabPanels>
                <TabPanel value={value} index={0}>
                    <DepartmentListTabPanel />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <UserListTabPanel />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ServiceListTabPanel />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <GuicheListTabPanel />
                </TabPanel>
            </TabPanels>
        </Box>
    );
}